// Configurable environment variable feature flags
// const enabledFeatures = {
//   speakers: process.env.FEATURE_SPEAKERS === "true",
//   sponsors: process.env.FEATURE_SPONSORS === "true",
//   merchandise: process.env.FEATURE_MERCH === "true",
//   communityChampions: process.env.FEATURE_BUSINESSES === "true",
//   otherEvents: process.env.FEATURE_EVENTS === "true",
//   youTubeVideos: process.env.FEATURE_VIDEOS === "true",
// };

const enabledFeatures = {
  speakers: true,
  sponsors: true,
  merchandise: true,
  communityChampions: true,
  otherEvents: true,
  youTubeVideos: true,
};

export default enabledFeatures;
